'use strict';
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input, index) {
    if (!input.id) input.id = "input-".concat(index);
    if (!input.parentElement.querySelector('label[for="'.concat(input.id, '"]'))) {
        var label = document.createElement('label');
        label.className = 'field-label';
        label.htmlFor = input.id;
        label.textContent = toLabelText(input.name);
        input.parentElement.insertBefore(label, input);
    }
    input.placeholder = toLabelText(input.name);
});
function toLabelText(str) {
    var clean = str.replace(/([A-Z])/g, ' $1').toLowerCase();
    return clean.charAt(0).toUpperCase() + clean.slice(1);
}

//# sourceMappingURL=js_task_fix_form_DOM.f7b0ee03.js.map
